import React, { useState } from "react";
import { FaCheck } from "react-icons/fa";
import useApi from "../../hooks/useApi";
import apiClient, { initializeApiClient } from "../../api/apiClient";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { useSelector } from "react-redux";

export default () => {
  const { userId } = useSelector((state) => state.auth);
  const initialData = {
    user: userId,
    app_status: false,
    location_services: false,
    motion_and_fitness: false,
    app_notifications: false,
  };
  const [submitData, setSubmitData] = useState(initialData);
  const [id, setId] = useState("");
  const handleChange = (key) => (e) => {
    setSubmitData({
      ...submitData,
      [key]: e.target.checked,
    });
  };

  const { request, loading, error } = useApi((submitData) =>
    apiClient.patch(`/settings/app-settings/${id}/`, submitData)
  );

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        initializeApiClient();
        const response = await apiClient.get("/settings/app-settings/");
        const data = response.data[0];
        setSubmitData(data);
        setId(data.id);
      } catch (error) {
        console.error("Error fetching settings:", error);
        toast.error("Failed to load settings. Please try again later.");
      }
    };

    fetchSettings();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const result = await request(submitData);

      if (result && result.data && result.data.id) {
        toast.success("Settings updated successfully");
        setSubmitData(result.data);
        setId(result.data.id);
      } else {
        toast.error("Unexpected response from server. Please try again.");
      }
    } catch (error) {
      console.error("Error updating settings:", error);
      toast.error(
        "An error occurred while updating settings. Please try again later."
      );
    }
  };

  const handleGPSRequest = () => {
    window.location.href = "mailto:rykar@rollingadz.com";
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="site-content h-100">
          <div className="p-4">
            <div className="site-content-body">
              <section className="notification-sec mt-4">
                <div className="container">
                  <div className="row notification-main d-flex justify-content-between">
                    <div className="col-lg-5  pe-lg-4">
                      <h3 className="notify-head blue-clr fs-3 fw-bold lh-base position-relative">
                        Location and Tracking
                      </h3>
                      <div className="mt-5">
                        <div className="mt-5">
                          <div className="toggle d-flex justify-content-between align-items-center">
                            <label
                              htmlFor="a_status"
                              className="blue-clr fs-4 fw-normal lh-base"
                            >
                              App Status
                            </label>
                            <input
                              checked={submitData?.app_status}
                              type="checkbox"
                              id="a_status"
                              className="notify-check"
                              onChange={handleChange("app_status")}
                            />
                          </div>
                        </div>
                        <div className="mt-3">
                          <div className="toggle d-flex justify-content-between align-items-center">
                            <label
                              htmlFor="l_notification"
                              className="blue-clr fs-4 fw-normal lh-base"
                            >
                              Location Services
                            </label>
                            <input
                              checked={submitData?.location_services}
                              type="checkbox"
                              id="l_notification"
                              className="notify-check"
                              onChange={handleChange("location_services")}
                            />
                          </div>
                        </div>
                        <div className="mt-3">
                          <div className="toggle d-flex justify-content-between align-items-center">
                            <label
                              htmlFor="p_notification"
                              className="blue-clr fs-4 fw-normal lh-base"
                            >
                              Motion and Fitness
                            </label>
                            <input
                              checked={submitData?.motion_and_fitness}
                              type="checkbox"
                              id="p_notification"
                              className="notify-check"
                              onChange={handleChange("motion_and_fitness")}
                            />
                          </div>
                        </div>
                        <h3 className="notify-head blue-clr position-relative mt-5 fs-3 fw-bold lh-base">
                          Notifications
                        </h3>
                        <div className="mt-4">
                          <div className="toggle d-flex justify-content-between align-items-center">
                            <label
                              htmlFor="e_report"
                              className="blue-clr fs-4 fw-normal lh-base"
                            >
                              Notifications
                            </label>
                            <input
                              checked={submitData?.app_notifications}
                              type="checkbox"
                              id="e_report"
                              className="notify-check"
                              onChange={handleChange("app_notifications")}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2 ps-lg-4 mt-5 mt-lg-0">
                      <div className="w-100 h-100 d-flex flex-column justify-content-center">
                        <p className="blue-clr fs-2 lh-base fw-normal text-center">
                          OR
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-5 ps-lg-4 mt-5 mt-lg-0">
                      <div>
                        <h3 className="notify-head blue-clr position-relative fs-3 fw-bold lh-base">
                          Rolling Adz GPS Device
                        </h3>
                      </div>
                      <div className="request-btn mt-5">
                        <button
                          type="button"
                          className="btn shadow-none rounded-pill w-100 fs-4 lh-base p-3"
                          onClick={handleGPSRequest}
                        >
                          Request
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col text-center mt-5 save-main">
                      <p className="blue-clr fs-5 mx-auto w-75 lh-sm">
                        Rolling Adz uses location services to match you with
                        advertisers where you regularly drive. To qualify for
                        campaigns, you will need to track at least 100 miles.
                      </p>
                      <button
                        type="submit"
                        className="btn_bgnone btn blue-clr fs-4 lh-base fw-normal"
                      >
                        <span className="pe-2">Save Changes</span>
                        <FaCheck />
                      </button>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
